export const PERMISSION = {
    USER: ["user"],
    TRADING: ["trading", "user"]
}